import type { ReactNode } from 'react';

import { Modal } from 'cpool-components/general/Modal';
import { Button } from 'cpool-components/input/Button';
import { useTranslation } from 'react-i18next';
import { LuX } from 'react-icons/lu';

type Props = {
    title: ReactNode;
    open: boolean;
    onClose: () => void;
    children: ReactNode;
    testId?: string;
};

export const InfoSidebarModal: React.FC<Props> = ({ children, onClose, open, testId, title }) => {
    const { t } = useTranslation();

    return (
        <Modal variant="sidebar" side="right" width="522px" open={open} onClose={onClose} title={title}>
            <div className="flex flex-col gap-4" data-testid={testId}>
                {children}
                <div className="flex justify-end">
                    <Button iconLeft={<LuX />} onClick={onClose}>
                        {t('BUTTONS.CLOSE')}
                    </Button>
                </div>
            </div>
        </Modal>
    );
};
